/*================================
	裁切圖片的controller
	Author : Gray
================================*/

angular.module('InifECApp').controller('ImageCropController', ['$scope', '$ngModal',
	function ($scope, $ngModal) {

 	var save = function(){
 		($scope.callback) && $scope.callback($scope.cropResult);
 	}

/*==========================
	Events
==========================*/
	$scope.$on("ON_CROP_IMAGE", function (e, data) {
		$ngModal.openModal('image-crop-modal');
		$scope.src = data.src;
		$scope.callback = data.callback;
		$scope.errorCallback = data.errorCallback;
		$scope.aspectRatio = data.aspectRatio;
		$scope.cropStyle = data.cropStyle;
	});

/*==========================
	Members
==========================*/
	$scope.src;
	$scope.cropResult;
	$scope.cropStyle;

/*==========================
	Methods
==========================*/
	$scope.save = save;
	// $scope.close = close;
	$scope.callback;
	$scope.errorCallback;

}]);


window.InifECApp.directive('cropImage', function() {
  return {
    restrict: 'AE',
    scope: {
    	src: "=src",
    	cropResult: "=cropResult",
    	aspectRatio: "=aspectRatio",
    	cropStyle: "=cropStyle"
    },
    link: function(scope, element, attr) {

    	function cropImage(){

    		if(scope.src){
	    		element.html('<img src="' + scope.src + '">');
	    		var $img = element.find('img');

	    		/* var img = new Image();
	    		img.src = scope.src;
	    		img.onload = function(){
	    			imgWidth = this.width;
	    			imgHeight = this.height;
	    		} */

	    		$img.load(function(){
	    			// scope.$apply(function(){
	    				var imgWidth = $img.width(),
							imgHeight = $img.height(),
							x1 = 0,
							x2 = 0,
							y1 = 0,
							y2 = 0;

						if(imgWidth >= imgHeight){
							x1 = imgWidth/2 - imgHeight/2;
							x1 = imgWidth/2 + imgHeight/2;
							y1 = 0;
							y2 = imgHeight;
						}else{
							x1 = 0;
							x2 = imgWidth;
							y1 = imgHeight/2 - imgWidth/2;
							y2 = imgHeight/2 + imgWidth/2;
						}

						if(scope.cropStyle){
							var posX,
								posY,
								coverSizeX,
								coverSizeY;

							if(scope.cropStyle["background-position"]){
								var backgroundPosition = scope.cropStyle["background-position"].split(" ");
								posX = parseInt(backgroundPosition[0]);
								posY = parseInt(backgroundPosition[1]);
							}

							if(scope.cropStyle["background-size"]){
								var backgroundPosition = scope.cropStyle["background-size"].split(" ");
								coverSizeX = parseInt(backgroundPosition[0]);
								coverSizeY = parseInt(backgroundPosition[1]);
							}

							if(!window.isNaN(posX) && !window.isNaN(posY) && !window.isNaN(coverSizeX) && !window.isNaN(coverSizeY)){
								var selectWidth = imgHeight * 100 / coverSizeY;
								var selectHeight = imgWidth * 100 / coverSizeX;
								x1 = (imgWidth - selectHeight) * posX / 100;
								y1 = (imgHeight - selectWidth) * posY / 100;
								x2 = x1 + selectHeight;
								y2 = y1 + selectWidth;
							}
						}

						$img.Jcrop({
							trackDocument: true,
							aspectRatio: scope.aspectRatio, // 1:1
							setSelect: [x1, y1, x2, y2],
							onChange: function(c){
								scope.$apply(function(){							
									// 這邊在console的地方一定會跑出 $apply already in progress 的錯誤訊息，請忽略
									scope.cropResult = {
										imgWidth: imgWidth,
										imgHeight: imgHeight,
										c: c
									};
								})
							}
						});

					// });
				})
	    	}else{
	    		element.html("");
	    	}
    	}

    	scope.$watch("src", function(newValue, oldValue) {
            cropImage();
        });

    }
  };
});